<template>
<inertia-head title="Membership Terms" />

<div>
    <breadcrumb>
        <breadcrumb-item>
            <inertia-link href="/">Hem</inertia-link>
        </breadcrumb-item>
        <breadcrumb-item :last="true">
            Medlemsvillkor
        </breadcrumb-item>
    </breadcrumb>

    <div class="main container page-content-padding">
        <h1 class="page-heading text-red">{{ $t('membership-terms') }}</h1>

        <div class="mt-4 underline">Senast uppdaterad: 2022-02-18</div>

        <p class="text-light-w justify-content subtitle-padding">
            Vad kul att du vill bli medlem! Nu kommer du helt gratis att få tillgång till massor med grymma
            erbjudanden och rabatter! Var snäll och börja med att läsa igenom och godkänna dessa
            medlemsvillkor som gäller för alla våra medlemmar.
        </p>
        <h2 class="subtitle subtitle-padding">Medlemskap</h2>
        <p class="text-light-w justify-content">
            Du blir enkelt medlem genom att ange informationen som efterfrågas vid registreringen. Ditt
            medlemskap är personligt och du ansvarar för att de uppgifter som du fyller i är korrekta, samt att de
            uppdateras i den mån du önskar. Om du anger felaktiga uppgifter vid registreringen, kan det medföra
            att ditt konto blir raderat. Var försiktig med dina inloggningsuppgifter och hantera dem på ett säkert
            sätt. Som medlem är du ytterst ansvarig för dina inloggningsuppgifter. Genom att godkänna dessa
            medlemsvillkor förbinder du dig också till att inte missbruka sajten eller medlemskapet genom att
            exempelvis skicka spam eller virus. Familjekortet Sverige AB har rätt att granska ditt medlemskonto
            om det misstänks att villkoren missbrukas. Medlem som inte uppfyller villkoren kan utan förvarning få
            sitt medlemskap avslutat.
        </p>
        <h2 class="subtitle subtitle-padding">Extra för dig som medlem</h2>
        <p class="text-light-w justify-content">
            Som medlem hos Familjekortet får du möjlighet att ta del av olika kampanjer, erbjudanden och rabatter
            från de företag som är anslutna till Familjekortet. Du får även tillgång till Mina Sidor, där du själv kan
            välja att komplettera dina kontaktuppgifter och ange intressen och födelsedagar för dig och dina barn.
            Vi ges då till exempel möjlighet att uppvakta er extra på födelsedagar. Som medlem kan du även få
            personligt anpassat innehåll på sajten och relevanta och utvalda erbjudanden som anpassats för dig
            utifrån dels ditt användande av sajten, men även hur du tidigare utnyttjat erbjudanden och rabatter.<br>
            <br>
            Vi kommunicerar vanligtvis via e-post, pushnotiser och andra digitala kanaler, som exempelvis annonsering på vår egen och externa webbsidor (t.ex. Facebook), men ibland kommunicerar vi även via t.ex. sms, Messenger, WhatsApp och brev. Du kan även komma att mottaga marknadsföring för vin.  Du kan när som helst kontakta oss via vårt <inertia-link href="/kontakta-oss">kontaktformulär</inertia-link>. Det kan även bli möjligt
            att göra personliga inställningar på Mina sidor, gällande hur du önskar att vi kommunicerar med dig.
            Vi kan inte kan hjälpa till med ändringar som gäller begränsningar när det gäller sociala nätverk. Det
            behöver du på egen hand ändra i inställningarna på respektive konto.
        </p>
        <h2 class="subtitle subtitle-padding">Avsluta ditt medlemskap</h2>
        <p class="text-light-w justify-content">
            Ditt medlemskap hos oss gäller tills vidare, men du kan när som helst avsluta ditt medlemskap
            genom att höra av dig till vår kundtjänst via vårt <inertia-link href="/kontakta-oss">kontaktformulär</inertia-link>. Om du väljer att avsluta ditt
            medlemskap raderas ditt konto. Om du inte har loggat in, handlat, eller över huvud taget interagerat
            med oss (genom att exempelvis kontakta kundtjänst) på ca. 36 månader kommer ditt medlemskap
            automatiskt att avslutas. Ditt medlemskap kan också avslutas av oss om du brutit mot
            medlemsvillkoren, eller på annat sätt missbrukat ditt medlemskap.
        </p>
        <h2 class="subtitle subtitle-padding">Ändringar av medlemsvillkor</h2>
        <p class="text-light-w justify-content">
            Familjekortet förbehåller sig rätten att göra ändringar i dessa medlemsvillkor när som helst i tiden.
            Alla ändringar av dessa medlemsvillkor kommer att publiceras på familjekortet.se, eller skickas ut via
            e-post. Vi rekommenderar dock att du håller dig uppdaterad på familjekortet.se regelbundet för att se
            om det sker eventuella ändringar av medlemsvillkoren.
        </p>
        <h2 class="subtitle subtitle-padding">Hur hanterar vi dina personuppgifter?</h2>
        <p class="text-light-w justify-content">
            För att ge dig en bästa möjlig upplevelse, så kan vi komma att personalisera sajten utifrån hur du
            interagerar med oss och vad vi tror att du tycker om. För att lyckas med detta behöver vi hantera och
            administrera dina personuppgifter. Mer information om hur vi behandlar dessa uppgifter hittar du i vår
            <inertia-link href="/integrity-policy">integritetspolicy</inertia-link>.
        </p>
        <h2 class="subtitle subtitle-padding">Frågor?</h2>
        <p class="text-light-w justify-content container-padding">
            Har du några som helst frågor om medlemskapet är du alltid välkommen att höra av dig till oss via vårt <inertia-link href="/kontakta-oss">kontaktformulär</inertia-link>.
        </p>
    </div>
    <inertia-link class="btn btn-danger cookies-button " href="/kampanjer">{{ $t('all_discounts') }}</inertia-link>
    </div>
</template>
